import { JoinSocialLeagueI18n } from "@/locales/base.message.locales";

export const join_social_league: JoinSocialLeagueI18n = {
  title: "Por que fazemos?",
  buttons: {
    contact_us: "Fale conosco",
    donate: "DOAR",
    join_today: "Participe agora"
  },
  texts: {
    p1: `Somos movidos pela paixão de criar um futuro de sustentabilidade e inovação,  com as pessoas. Por isso, em tudo o que fazemos, está o compromisso de cocriar soluções para gerar mudanças reais e duradouras. A Ikone é uma Aceleradora do Desenvolvimento Sustentável que,  através da sua plataforma multilateral de inovação aberta, aprendizagem ESG, prototipação e aceleração de novas soluções quer promover um novo modelo de Desenvolvimento Econômico e Social.`,
    p2: `Na Ikone acreditamos que transformar o mundo começa pela transformação de vidas  e territórios.`
  }
};
